import React, { useContext } from "react";
import PropTypes from "prop-types";

import {
  Textarea,
  Column,
  Field,
  Control,
  Label,
  Input,
  Icon,
  Button
} from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  SystemCodeSelect,
  BooleanInput,
  StateSelect,
  ZipCodeInput,
  DateInput,
  CustomerSelect
} from "../../../../components/inputs";

import Types from "./Types";

import { ModalContext } from "../../../../components/ModalProvider";

import { AddLocationTypeForm } from "../../../../components/Locations";

const Details = ({ editing, locationData, onChange }) => {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field kind="group">
            <Control expanded>
              <Label>Location Id</Label>
              <Input
                required
                autocomplete="new"
                name="LocationID"
                readOnly={!editing}
                value={locationData.LocationID}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Location Name</Label>
              <Input
                required
                autocomplete="new"
                name="LocationName"
                readOnly={!editing}
                type="text"
                value={locationData.LocationName}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <Label>Address 1</Label>
              <Input
                autocomplete="new"
                name="Address1"
                readOnly={!editing}
                type="text"
                value={locationData.Address1}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Address 2</Label>
              <Input
                autocomplete="new"
                name="Address2"
                readOnly={!editing}
                type="text"
                value={locationData.Address2}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <Label>Loading Bays</Label>
              <Input
                autocomplete="new"
                name="NumberOfLoadingBays"
                readOnly={!editing}
                type="number"
                value={locationData.NumberOfLoadingBays}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Unloading Bays</Label>
              <Input
                autocomplete="new"
                label="NumberOfUnloadingBays"
                name="NumberOfUnloadingBays"
                readOnly={!editing}
                type="number"
                value={locationData.NumberOfUnloadingBays}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field kind="group">
            <Control expanded>
              <CustomerSelect
                icon="users"
                label="Bill To Customer"
                name="BillToRecIdRef"
                readOnly={!editing}
                value={locationData.BillToRecIdRef}
                variables={{
                  where: { Active: true, BillToCust: true },
                  orderByMulti: ["CustomerNo_ASC"]
                }}
                onChange={onChange}
                // showHelp
              />
            </Control>
            <Control expanded>
              <Label>Last Used Date</Label>
              <DateInput
                name="LastUsedDate"
                readOnly={!editing}
                value={locationData.LastUsedDate}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <Label>City</Label>
              <Input
                autocomplete="new"
                name="City"
                readOnly={!editing}
                type="text"
                value={locationData.City}
                onChange={onChange}
              />
            </Control>

            <Control expanded>
              <Label>State</Label>
              <StateSelect
                name="State"
                readOnly={!editing}
                size=""
                value={locationData.State}
                onChange={onChange}
              />
            </Control>

            <Control expanded>
              <Label>Zip Code</Label>
              <ZipCodeInput
                name="Zip"
                readOnly={!editing}
                value={locationData.Zip}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field kind="group">
            <Control expanded>
              <Label>Pickup Loc.</Label>
              <BooleanInput
                name="PickupLocation"
                readOnly={!editing}
                value={locationData.PickupLocation}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Delivery Loc.</Label>
              <BooleanInput
                name="DeliveryLocation"
                readOnly={!editing}
                value={locationData.DeliveryLocation}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Scales</Label>
              <BooleanInput
                name="Scales"
                readOnly={!editing}
                value={locationData.Scales}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                readOnly={!editing}
                value={locationData.Active}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <Label>Country</Label>
              <Input
                autocomplete="new"
                name="Country"
                readOnly={!editing}
                type="text"
                value={locationData.Country}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <SystemCodeSelect
                icon="globe"
                label="Time Zone"
                lookup={{ Category: "Company", Code: "Time Zone" }}
                name="TimeZoneRecIdRef"
                readOnly={!editing}
                value={locationData.TimeZoneRecIdRef}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Special External Instructions</Label>
              <Textarea
                disabled={!editing}
                name="SpecialExternalInstructions"
                rows="4"
                value={locationData.SpecialExternalInstructions}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Internal Notes</Label>
              <Textarea
                disabled={!editing}
                name="InternalNotes"
                rows="4"
                value={locationData.InternalNotes}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <div className="subpage">
        <div className="page-head">
          <div className="page-head-start" />
          <div className="page-head-end">
            <Field>
              <Control>
                <Button
                  size="small"
                  onClick={() =>
                    setModalOpen(
                      true,
                      <AddLocationTypeForm
                        id={locationData.RecId}
                        onComplete={() => setModalOpen(false, "")}
                      />
                    )
                  }
                >
                  <Icon>
                    <FontAwesomeIcon icon="plus" />
                  </Icon>
                  <span>Add Type</span>
                </Button>
              </Control>
            </Field>
          </div>
        </div>
        <Types locationRecId={locationData.RecId} />
      </div>
    </React.Fragment>
  );
};
Details.propTypes = {
  editing: PropTypes.bool,
  locationData: PropTypes.object,
  onChange: PropTypes.func
};
Details.defaultProps = {
  locationData: {}
};
export default Details;
